<template>
  <div class="page">
    <div class="item">
      <img class="img"
           src="https://is2-ssl.mzstatic.com/image/thumb/PurpleSource116/v4/2e/5d/06/2e5d06e2-42b1-8866-8c51-c6fd3d3bc667/b6de7170-9693-4cc4-99bb-13ae784a30d8_1.png/400x800bb.png"
           alt="">
    </div>

    <div class="item">
      <img class="img"
           src="https://is1-ssl.mzstatic.com/image/thumb/PurpleSource126/v4/f1/f2/6d/f1f26d56-6a98-1d23-ed77-890d9991869b/fe03f0eb-29b4-42b5-a57b-a2586d9e7ad4_2.png/400x800bb.png"
           alt="">
    </div>

    <div class="item">
      <img class="img"
           src="https://is5-ssl.mzstatic.com/image/thumb/PurpleSource126/v4/cb/09/9a/cb099a1a-85f0-dcff-b590-21dbfd524944/2c5ce7c1-9883-4618-a0e8-4915eef18007_3.png/400x800bb.png"
           alt="">
    </div>

    <div class="item">
      <img class="img"
           src="https://is1-ssl.mzstatic.com/image/thumb/PurpleSource126/v4/be/b1/2b/beb12bd4-295c-2e1a-47c7-97fa2210e800/d7d7bd0e-68a9-42e1-8cc3-5ef7c65d525e_4.png/400x800bb.png"
           alt="">
    </div>
    <div class="info">
      <div class="logo">
        <img class="i"
             src="../assets/images/trend_logo.png"
             alt="">
        <div class="t">看看拍什么</div>
      </div>
      <div class="title">联系方式</div>
      <div class="list">
        <div class="l">公司名称:</div>
        <div class="r">看看世界文化科技（北京）有限公司</div>
      </div>
      <div class="list">
        <div class="l">公司地址:</div>
        <div class="r">北京市朝阳区酒仙桥路6号</div>
      </div>
      <div class="list">
        <div class="l">联系邮箱:</div>
        <div class="r">pdt@show.world</div>
      </div>
      <div class="list">
        <div class="l">网站备案:</div>
        <div class="r">京ICP备19042276号-5</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  width: 100%;
  margin: 0 auto;
}

.item {
  width: 100%;
  height: auto;
}
.item .img {
  width: 100%;
  height: 100%;
}
.info {
  width: 90%;
  height: auto;
  margin: 0 auto 0;
  padding-bottom: 40px;
}
.info .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  border-bottom: solid 1px #ffffff;
}
.info .logo .i {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.info .logo .t {
  display: inline-block;
  line-height: 30px;
  font-size: 20px;
  color: #ffffff;
}
.info .list {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.info .list .l {
  color: #ffffff;
  font-size: 12px;
}
.info .list .r {
  color: #ffffff;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Support.vue